import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeolocationService } from '../services/geolocationservice';
import { sweetalert } from "../services/sweetalert";
@Component({
  selector: 'app-managecard',
  templateUrl: './managecard.component.html',
  styleUrls: ['./managecard.component.css']
})
export class ManagecardComponent implements OnInit {
  custmerId: string;
  mobileNo:string;
  manageCardData: any;
  loader:boolean=false;
  emiCardName:any;
  emiCardNumber:any;
  emiCardValidUpto:any;
  encryptData:any;
 
  constructor(private router: Router,
    private service: GeolocationService, private sweetalert: sweetalert) { }

  ngOnInit(): void {
    this.loader = true;
    console.log("loader::" + this.loader);

    this.custmerId=localStorage.getItem("custmerId");
    this.mobileNo=localStorage.getItem("mobileNo");
    this.encryptData=localStorage.getItem("encryptData");

     this.emiCardName=localStorage.getItem("emicardname");
     this.emiCardNumber=localStorage.getItem("emicardnumber");
     this.emiCardValidUpto=localStorage.getItem("emicardvalidupto");

     let reqObject = {
      custID: `${this.custmerId}`,
      mobile: `${this.mobileNo}`,
      data: `${this.encryptData}`
    }
     
    //  console.log("custmerId"+this.custmerId);
    //  console.log("mobileNo"+this.mobileNo);

    //   localStorage.setItem("custmerId", this.custmerId);
    //   localStorage.setItem("mobileNo", this.mobileNo);
    
    this.service.getManageCard(reqObject).subscribe(
      (data: any) => {
        this.manageCardData = JSON.parse(data?.data);


        if (typeof (data) === 'object') {
          console.log("event:" + JSON.stringify(data));
          
          this.manageCardData = JSON.parse(data.data);
          
          console.log(JSON.stringify(this.manageCardData))
    
          
        
         if (data.statusCode == 'EX') {

            this.loader = false;

          } else if (data.statusCode == 'SR') {
            this.loader = false;
          }

        }


      });
    this.loader = false;
  }
  onKYCClick(e: Event) {
    e.preventDefault();
   
    
    if (this.manageCardData?.KYC_STATUS?.toLowerCase() == 'n') {
      this.sweetalert.success_sweertalert(
        'KYC Completed'
      );
      
    } else {
      if(this.manageCardData?.KYC_URL){
       // window.open(this.manageCardData?.KYC_URL);
       window.location.href=this.manageCardData?.KYC_URL;
      }
    }
  }
  onRepaymentStatus(e: Event) {
    e.preventDefault();
    if (this.manageCardData?.EMANDATE_STATUS?.toLowerCase() == 'n') {
      this.sweetalert.success_sweertalert(
        'E-Mandate completed'
      );
    } else {
      if(this.manageCardData?.EMANDATE_URL){
        // window.open(this.manageCardData?.EMANDATE_URL);
        window.location.href = this.manageCardData?.EMANDATE_URL;
    }
  }
  }
  onDate(e: Event) {
    e.preventDefault();
    this.sweetalert.success_sweertalert('YOUR CARD IS VALID UPTO '+ this.manageCardData?.VALID_TILL);
  }

}
